import React from "react";
import OrganizerPillSelect from "../components/OrganizerPillSelect";
import { CLOSE_HOURS_OPTIONS } from "./clubOpenMatches";
import "./ClubBirthdaysTab.css";

/*
 * PARTIDOS ABIERTOS tab of the club form (Falta un jugador). Pure view over `clubForm.openMatches`: every
 * change goes through `onChange(updater)` and the club form saves it with the rest of the club
 * (buildClubFormData). Modeled on ClubBirthdaysTab, whose switch/panel styles it reuses.
 * The back closes an incomplete match `closeHours` before the slot and applies the creator's choice
 * (cancel or keep); each player pays their share at the club, so there is nothing to configure about money.
 */
const ClubOpenMatchesTab = ({ value, onChange }) => {
  const patch = (partial) => onChange((prev) => ({ ...prev, ...partial }));

  return (
    <div className="zr-bday">
      <label className="zr-bday__enable">
        <input
          type="checkbox"
          className="zr-switch"
          aria-label="Permitir partidos abiertos"
          checked={value.enabled}
          onChange={(e) => patch({ enabled: e.target.checked })}
        />
        <span>
          <b>Permitir partidos abiertos</b>
          <span className="zr-bday__enable-hint">
            Los jugadores pueden abrir un partido en un turno libre y otros se suman hasta completarlo.
          </span>
        </span>
      </label>

      <section className="zr-panel" aria-labelledby="om-cierre">
        <div className="zr-section-head">
          <h2 className="zr-section-head__title" id="om-cierre">Cierre automático</h2>
          <p className="zr-section-head__hint">| Cuánto antes del turno se decide si el partido sigue.</p>
        </div>
        <div className="zr-field">
          <span className="zr-field__label">Cierre del partido</span>
          <OrganizerPillSelect
            value={value.closeHours}
            onChange={(hours) => patch({ closeHours: Number(hours) })}
            options={CLOSE_HOURS_OPTIONS}
            disabled={!value.enabled}
          />
        </div>
        <p className="zr-section-head__hint">Cada jugador paga su parte en el club.</p>
        <p className="zr-section-head__hint">
          Si a la hora de cierre no se completó, se aplica lo que eligió quien lo creó (cancelar o mantener).
        </p>
      </section>
    </div>
  );
};

export default ClubOpenMatchesTab;
